import 'bootstrap';
import Masonry from 'masonry-layout';
import Snap from './vendor/snap';
import Navigation from "./components/navigation";

$(function () {
    let masonry, snapper;
    const masonryOptions = {
        itemSelector: '.item2',
        columnWidth: '.item2',
    };
    const masonryContainer = document.getElementById('container');
    const snapperElement = document.getElementById('content');
    const homePage = document.querySelector('.HomePage');

    if (masonryContainer) {
        masonry = new Masonry(masonryContainer, masonryOptions);
    }

    if (snapperElement) {
        snapper = new Snap({
            element: document.getElementById('content')
        });

        Navigation(snapper);

        snapper.on('open', function() {
            $('.fa-discover').removeClass('fa-chevron-right').addClass('fa-chevron-left');
            setTimeout(function() {
                if (masonryContainer)
                    masonry.layout();
            }, 500);
        });

        snapper.on('close', function() {
            $('.fa-discover').removeClass('fa-chevron-left').addClass('fa-chevron-right');
            setTimeout(function() {
                if (masonryContainer)
                    masonry.layout();
            }, 500);
        });

        if (homePage) {
            setTimeout(function() {
                snapper.open('left');
            }, 3000);
        }
    }
});
